import { useEffect, useState } from 'react'
import cbLogoIcon from "../../assets/images/CB LOGO ICON.png";

export default function CloseNotice() {

    const [time, setTime] = useState(new Date());

    useEffect(() => {
        const timer = setInterval(() => {
            setTime(new Date());
        }, 1000); // updates every second

        return () => clearInterval(timer);
    }, []);

    const currentHour = time.getHours();
    const currentMinute = time.getMinutes();

    const isMorningClosed = currentHour < 10 || (currentHour === 0 && currentMinute >= 1);
    const isNightClosed = currentHour > 21 || (currentHour === 21 && currentMinute >= 31);


    return (
        <div className='bg-white rounded-md w-full h-full p-4 flex-1 flex flex-col space-y-3 overflow-hidden'>
            <div className=" w-full h-full p-8 flex-1 flex flex-col justify-center items-center text-center">
                <div className="relative z-10 space-y-2">
                    <div className="flex justify-center">
                        <div className="w-[150px] h-[150px] flex items-center justify-center overflow-hidden">
                            <img
                                src={cbLogoIcon} 
                                alt="Capital Brew"
                                className="w-full h-full object-contain"
                            />
                        </div>
                    </div>

                    {isMorningClosed && ( 
                        <> 
                            <h2 className="text-2xl md:text-3xl font-bold text-gray-800 tracking-tight">
                                Oops! You’re a bit early!
                            </h2>
                            <p className="mx-auto text-center text-gray-600 max-w-md leading-relaxed">
                                Our beans and baristas are getting ready for the day. Capital Brew is open from <span className="font-semibold text-cbColor">10:00 am</span> to <span className="font-semibold text-cbColor">9:30 pm</span>. Stay cozy – we’ll be serving your brew fix soon!
                            </p>
                        </>
                    )}
                    {isNightClosed && (
                        <>
                            <h2 className="text-2xl md:text-3xl font-bold text-gray-800 tracking-tight">
                                Oops! You’re too early for tomorrow!
                            </h2>
                            <p className="mx-auto text-center text-gray-600 max-w-md leading-relaxed">
                                Our beans and baristas are just taking a break. Capital Brew is open from <span className="font-semibold text-cbColor">10:00 am</span> to <span className="font-semibold text-cbColor">9:30 pm</span>. Stay cozy – we’ll be serving your brew fix soon!
                            </p>
                        </>
                    )}
                </div>
            </div>
        </div>
    )
}
